// extracted by mini-css-extract-plugin
export var logo = "_ca-2";
export var logoWrapper = "_ca-1";
export var strip = "_ca-0";